import React from "react";
import { useAppContext } from "../../context/appContext";

const MenuItem = (props) => {
    const { addItem } = useAppContext();

    const addItemHandler = () => {
        addItem({ id: props.id, name: props.name, price: props.price });
    };

    return (
        <div
            data-id={props.id}
            onClick={addItemHandler}
            className='flex h-[6rem] min-w-[200px] flex-1 flex-grow-0 cursor-pointer flex-col justify-between self-stretch rounded-lg bg-gray-200 text-lg font-medium text-black '
        >
            <div className='ml-4 mt-1 h-[60px] truncate  text-ellipsis whitespace-pre-wrap'>
                <span>{props.name || "Test"}</span>
            </div>
            <div className='ml-4 mt-1'>{props.price || "44.22"} £</div>
        </div>
    );
};

export default MenuItem;
